<template>
	<div class="p-col-12 p-grid">
		<div class="p-col-12 p-lg-6" :class="[commonService.isMobile() ? 'text-box-mobile' : 'text-box']">
			<p class="login-subtitle">Why choose The TiroLibre transfer platform?</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">With over 5000 clubs across Europe receiving daily recommendations and initiating real-time negotiations, TiroLibre offers a unique opportunity to stay ahead of the competition during the crucial transfer window.</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">But that's not all - our platform also provides Players data and player evaluation tools, a secure and transparent negotiation process, dedicated 24/7 support from our expert team, access to a comprehensive player and club database, and regular updates on transfers on going and opportunities. </p>
			<p v-if="commonService.isMobile()" class="login-text justified">TiroLibre is the ultimate platform for staying ahead in the transfer market. Connect with over 5000 clubs across Europe, receive daily recommendations, and negotiate in real-time. </p>
			<p v-if="commonService.isMobile()" class="login-text justified">Our platform provides player data and evaluation tools, a secure and transparent process, 24/7 expert support, and access to a comprehensive player and club database. Stay updated on the latest transfers and opportunities with TiroLibre.</p>
			<div v-if="!commonService.isMobile()" :class="isSmallScreen()? 'p-col-5 button-box' : 'p-lg-3 button-box'" style="padding: 0px">
				<Button label="Become an associate" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
		<div class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomeAgent2ImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
			<div v-if="commonService.isMobile()" class="p-col-6 button-box-mobile" style="margin-top: -30px; margin-bottom: 30px">
				<Button label="Become an associate" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
		isSmallScreen() {
			return screen.width <= 1600 ? true : false;
		},
	},
};
</script>

<style scoped>
.justified {
	text-align: justify;
	text-justify: inter-word;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -80px;
	font-size: xx-large;
	font-weight: bold;
}

.login-text {
	margin-top: 10px;
	font-size: 19px;
}

.text-box {
	margin: auto;
	padding-left: 50px;
}

.text-box-mobile {
	margin: auto;
}

.button-box {
	margin-top: 20px;
}

.button-box-mobile {
	margin: auto;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-title {
		margin-top: -15px;
		font-size: 45px;
		font-weight: bold;
	}

	.login-subtitle {
		margin-top: 40px;
		font-size: x-large;
		font-weight: bold;
	}

	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}
}
</style>